import { withI18n } from 'panda-i18n';
import { CnDialogFullpage as CnDialogFullpageView } from './fullpage';
import locale from '@/locale';
import './index.scss';
export var CnDialogFullpage = withI18n(CnDialogFullpageView, { locale: locale });
